import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Armchair, Coffee, Scissors, UserCheck } from 'lucide-react';
const features = [{
  icon: Armchair,
  title: 'Atención Sin Prisas',
  description: 'Cada cita tiene el tiempo necesario para alcanzar la excelencia. Tu imagen no se apresura.'
}, {
  icon: Scissors,
  title: 'Cortes de Autor',
  description: 'Expertos en equilibrar el estilo Old School con las tendencias modernas y técnicas avanzadas.'
}, {
  icon: Coffee,
  title: 'Ambiente Exclusivo',
  description: 'Relájate con una bebida de cortesía (whisky, café o cerveza) mientras transformamos tu look.'
}, {
  icon: UserCheck,
  title: 'Asesoría de Imagen',
  description: 'No solo cortamos; te aconsejamos qué estilo potencia mejor tus rasgos y estructura facial.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Solution() {
  return <section className="py-24 px-6 bg-charcoal-900" data-id="element-118">
      <div className="container mx-auto max-w-6xl" data-id="element-119">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-120">
          <span className="text-gold-500 font-sans tracking-widest text-sm uppercase mb-4 block" data-id="element-121">
            La Experiencia MA
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-cream" data-id="element-122">
            Mucho más que una barbería.
            <br data-id="element-123" />
            <span className="text-gold-400 italic" data-id="element-124">
              Una experiencia Premium.
            </span>
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-125">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-charcoal-800 border border-charcoal-700 p-8 rounded-sm hover:border-gold-500/30 transition-colors duration-300 group" data-id="element-126">
                <div className="w-14 h-14 bg-charcoal-900 flex items-center justify-center rounded-full mb-6 border border-charcoal-700 group-hover:border-gold-500/50 transition-colors duration-300" data-id="element-127">
                  <Icon className="text-gold-400" size={24} strokeWidth={1.5} data-id="element-128" />
                </div>
                <h3 className="text-xl font-serif text-cream mb-3" data-id="element-129">
                  {feature.title}
                </h3>
                <p className="text-cream-muted font-light text-sm leading-relaxed" data-id="element-130">
                  {feature.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}